export const radius = {
  sm: 4,
  md: 8,
  lg: 16,
  xl: 32,
};